import type { ControlledColumn } from './ColumnControl';

export const getIsAllColumnUnselected = (
  selectedColumns: Record<string, boolean>,
  columns: ControlledColumn[]
): boolean => columns.every(({ disableHiding, id }) => disableHiding || !selectedColumns[id]);
